import React, { useEffect, useState } from "react";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import './styles.css'
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import {
    employeeDetailRequest, removeEmployeeFromBusinessRequest, removeEmployeeFromBusinessRequestStatus,
    employeeUpdateDetailsRequest, employeeUpdateDetailsRequestStatus, employeeListRequest
} from '../../../redux/employee/employee.action'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";
import CommonButton from "../../../components/button/common-button/commonButton";
import CommonColorForm from "../../../components/common-color-form/commonColorForm";
import { checkFunctionalityPermission, isPermissionAllowed, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import Select from 'react-select'
import Modal from 'react-bootstrap/Modal';
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";

const EmployeeDetail = props => {
    const { state } = useLocation()
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    const { employeeDetailSuccess, employeeDetailError,
        employeeListSuccess, employeeListError,
        removeEmpFromBusinessSuccess, removeEmpFromBusinessError, removeEmpFromBusinessReqStatus,
        employeeUpdateDetailsSuccess, employeeUpdateDetailsError, employeeUpdateDetailsReqStatus } = useSelector(state => state.employee)
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector((state) => state.user)
    const [role, setRole] = useState('')
    const [employeeCode, setEmployeeCode] = useState('')
    const [employeeType, setEmployeeType] = useState()
    const employeeTypeList = [
        { key: 'FULL_TIME', value: 'Full Time' },
        { key: 'CONTRACTUAL', value: 'Contractual' },
        { key: 'PROJECT_BASED', value: 'Project Based' },
    ]
    const [selectedManager, setSelectedManager] = useState(null)
    const [showEmployeeModal, setShowEmployeeModal] = useState(false)
    const [isLocationPermission, setIsLocationPermission] = useState(false)
    const [addLocationPermission, setAddLocationPermission] = useState(false)
    const [updateLocationPermission, setUpdateLocationPermission] = useState(false)

    const [isEmployeePermission, setIsEmployeePermission] = useState(false)
    const [addEmployeePermission, setAddEmployeePermission] = useState(false)
    const [removeEmployeePermission, setRemoveEmployeePermission] = useState(false)
    const [updateEmployeePerPermission, setUpdateEmployeePerPermission] = useState(false)

    const [isProjectPermission, setIsProjectPermission] = useState(false)
    const [addProjectPermission, setAddProjectPermission] = useState(false)
    const [updateProjectPermission, setUpdateProjectPermission] = useState(false)
    const [viewProjectCostingPermission, setViewProjectCostingPermission] = useState(false)
    const [updateProjectEmployeeRequestPermission, setUpdateProjectEmployeeRequestPermission] = useState(false)

    const [isShiftPermission, setIsShiftPermission] = useState(false)
    const [addShiftPermission, setAddShiftPermission] = useState(false)
    const [updateShiftDetailsPermission, setUpdateShiftDetailPermission] = useState(false)
    const [updateShiftEmployeeRequestPermission, setUpdateShiftEmployeeRequestPermission] = useState(false)

    const [isTaskPermission, setIsTaskPermission] = useState(false)
    const [addTaskPermission, setAddTaskPermission] = useState(false)
    const [assignTaskPermission, setAssignTaskPermission] = useState(false)
    const [removeEmployeeTaskPermission, setRemoveEmployeeTaskPermission] = useState(false)

    const [isRequestPermission, setIsRequestPermission] = useState(false)
    const [acceptOrRejectRequestPermission, setAcceptOrRejectRequestPermission] = useState(false)

    const [isDocumentPermission, setIsDocumentPermission] = useState(false)
    const [addDocumentPermission, setAddDocumentPermission] = useState(false)

    const [isPolicyPermission, setIsPolicyPermission] = useState(false)
    const [addPolicyPermission, setAddPolicyPermission] = useState(false)

    const [isAssetPermission, setIsAssetPermission] = useState(false)
    const [viewAllAssetsPermission, setViewAllAssetsPermission] = useState(false)
    const [addAssetPermission, setAddAssetPermission] = useState(false)
    const [assignAssetPermission, setAssignAssetPermission] = useState(false)
    const [updateAssetPermission, setUpdateAssetPermission] = useState(false)

    const [isAuditPermission, setIsAuditPermission] = useState(false)
    const [viewAllAuditPermission, setViewAllAuditPermission] = useState(false)
    const [newAuditPermission, setNewAuditPermission] = useState(false)
    const [updateAuditStatusPermission, setUpdateAuditPermission] = useState(false)
    const [assignAuditPermission, setAssignAuditPermission] = useState(false)

    const [isVisitorPermission, setIsVistorPermission] = useState(false)
    const [viewVisitorBookPermission, setViewVisitorBookPermission] = useState(false)
    const [updateVisitorFormSettingPermission, setUpdateVisitorFormSettingPermission] = useState(false)

    const [isPayrollPermission, setIsPayrollPermission] = useState(false)
    const [manageTaxRulePermission, setManageTaxRulePermission] = useState(false)
    const [manageEmployeePayrollPermission, setManageEmployeePayrollPermission] = useState(false)

    const [isSuppliesPermission, setIsSuppliesPermission] = useState(false)
    const [addMerchantPermission, setAddMerchantPermission] = useState(false)
    const [manageMerchantPermission, setManageMerchantPermission] = useState(false)
    const [viewCategoriesPermission, setViewCategoriesPermission] = useState(false)
    const [addCategoriesPermission, setAddCategoriesPermission] = useState(false)
    const [viewItemPermission, setViewItemPermission] = useState(false)
    const [addItemPermission, setAddItemPermission] = useState(false)
    const [manageItemPermission, setManageItemPermission] = useState(false)

    const [showRoleInput, setShowRoleInput] = useState(false)
    const [searchQuery, setSearchQuery] = useState('')

    const [showRemoveEmployeeModal, setShowRemoveEmployeeModal] = useState(false)
    const [reason, setReason] = useState('')
    const [feedback, setFeedback] = useState('')
    const [endDate, setEndDate] = useState(new Date())

    useEffect(() => {
        fetchEmployeeDetail()
    }, [])

    const fetchEmployeeDetail = () => {
        setLoading(true)
        dispatch(employeeDetailRequest(state.employeeId))
    }

    useEffect(() => {
        if (removeEmpFromBusinessReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(removeEmpFromBusinessSuccess.message)
            navigate(-1)
        } else if (removeEmpFromBusinessReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(removeEmpFromBusinessError.message)
        }
        if (removeEmpFromBusinessReqStatus.length) {
            dispatch(removeEmployeeFromBusinessRequestStatus(''))
        }
    }, [removeEmpFromBusinessSuccess, removeEmpFromBusinessError, removeEmpFromBusinessReqStatus])

    useEffect(() => {
        if (employeeUpdateDetailsReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(employeeUpdateDetailsSuccess.message)
            fetchEmployeeDetail()
        } else if (employeeUpdateDetailsReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(employeeUpdateDetailsError.message)
        }
        if (employeeUpdateDetailsReqStatus?.length) {
            dispatch(employeeUpdateDetailsRequestStatus(''))
        }
    }, [employeeUpdateDetailsSuccess, employeeUpdateDetailsError, employeeUpdateDetailsReqStatus])

    useEffect(() => {
        if (!isNull(employeeDetailSuccess)) {
            setLoading(false)
            showAllowedPermissions()
            if (!isEmpty(employeeDetailSuccess.data?.employeeBusinessMapping)) {
                let mappingObj = employeeDetailSuccess.data?.employeeBusinessMapping.find(item => parseFloat(item.businessId) === parseFloat(state.businessId))
                if (!isEmpty(mappingObj)) {
                    setRole(mappingObj.role)
                    setEmployeeCode(mappingObj.employeeCode)
                    if (!isEmpty(mappingObj.supervisorDetail)) {
                        setSelectedManager(mappingObj.supervisorDetail)
                    }
                    let empType = employeeTypeList.find(empType => empType.key === mappingObj.employeeType)
                    if (!isEmpty(empType)) {
                        setEmployeeType(empType)
                    }
                }
            }
        } else if (!isNull(employeeDetailError)) {
            setLoading(false)
            displayErrorToast(employeeDetailError.message)
        }
    }, [employeeDetailSuccess, employeeDetailError])

    useEffect(() => {
        if (!isEmpty(employeeListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(employeeListError)) {
            setLoading(false)
        }
    }, [employeeListSuccess, employeeListError])

    const fetchEmployeeList = () => {
        setLoading(true)
        const data = {
            businessId: state.businessId
        }
        if (!isEmpty(searchQuery)) {
            data.searchQuery = searchQuery
        }
        dispatch(employeeListRequest(data))
    }

    const handleRemoveEmployee = () => {
        if (isEmpty(reason)) {
            displayErrorToast('Employee remove reason cannot be blank')
        } else {
            const data = {
                employeeId: employeeDetailSuccess.data.employeeId,
                businessId: state.businessId,
                locationId: state.locationId,
                reason: reason
            }
            if (!isEmpty(feedback)) {
                data.feedback = feedback
            }
            if (!isEmpty(endDate)) {
                data.endDate = endDate
            }
            setLoading(true)
            dispatch(removeEmployeeFromBusinessRequest(data))
        }

    }

    const getSalaryDetails = (salaryList) => {
        const salaryObj = salaryList.find(item => parseFloat(item.businessId) === state.businessId && parseFloat(item.locationId) === state.locationId)
        return salaryObj
    }

    const getSalaryDeductionDetails = (salaryList) => {
        const salaryObj = salaryList.find(item => parseFloat(item.businessId) === state.businessId && parseFloat(item.locationId) === state.locationId)
        return salaryObj
    }

    const handleUpdateDetails = () => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else if (isLoggedInUserEmployee(user) && parseFloat(state.employeeId) === parseFloat(user.data.userDetails.employeeId)) {
            displayErrorToast('Self information update is not allowed.')
        } else if (isEmpty(employeeDetailSuccess)) {
            displayErrorToast('Employee details not available. Please try refreshing the page')
        } else if (showRoleInput === true && isEmpty(role)) {
            displayErrorToast('Employee role cannot be blank')
        } else {
            setLoading(true)
            const data = {
                employeeId: state.employeeId,
                businessId: state.businessId
            }
            if (!isEmpty(selectedManager)) {
                data.supervisorId = selectedManager.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? selectedManager.employeeId : selectedManager.userId
                data.supervisorType = selectedManager.userType
            }
            if (!isEmpty(role)) {
                data.role = role
            }
            if (!isEmpty(employeeType)) {
                data.employeeType = employeeType.key
            }
            let businessId = state.businessId
            let locationId = state.locationId
            const existingPermissions = employeeDetailSuccess.data.permissions
            let filteredPermissions = existingPermissions.filter(e => parseFloat(e.businessId) !== parseFloat(businessId) && parseFloat(e.locationId) !== parseFloat(locationId))
            if (isLocationPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.LOCATION,
                    businessId: state.businessId,
                    locationId: state.locationId
                }
                obj[PERMISSION_SUB_TYPE.LOCATION.ADD_LOCATION] = addLocationPermission
                obj[PERMISSION_SUB_TYPE.LOCATION.UPDATE_LOCATION] = updateLocationPermission
                filteredPermissions.push(obj)
            }
            if (isEmployeePermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.EMPLOYEE,
                    businessId: state.businessId,
                    locationId: state.locationId
                }
                obj[PERMISSION_SUB_TYPE.EMPLOYEE.ADD_EMPLOYEE] = addEmployeePermission
                obj[PERMISSION_SUB_TYPE.EMPLOYEE.REMOVE_EMPLOYEE] = removeEmployeePermission
                obj[PERMISSION_SUB_TYPE.EMPLOYEE.UPDATE_EMPLOYEE] = updateEmployeePerPermission
                filteredPermissions.push(obj)
            }
            if (isProjectPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.PROJECT,
                    businessId: state.businessId,
                    locationId: state.locationId
                }
                obj[PERMISSION_SUB_TYPE.PROJECT.ADD_PROJECT] = addProjectPermission
                obj[PERMISSION_SUB_TYPE.PROJECT.UPDATE_DETAILS] = updateProjectPermission
                obj[PERMISSION_SUB_TYPE.PROJECT.VIEW_COSTING] = viewProjectCostingPermission
                obj[PERMISSION_SUB_TYPE.PROJECT.ACCEPT_REJECT_EMPLOYEE_REQUEST] = updateProjectEmployeeRequestPermission
                filteredPermissions.push(obj)
            }
            if (isShiftPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.SHIFT,
                    businessId: state.businessId,
                    locationId: state.locationId
                }
                obj[PERMISSION_SUB_TYPE.SHIFT.ADD_SHIFT] = addShiftPermission
                obj[PERMISSION_SUB_TYPE.SHIFT.UPDATE_SHIFT] = updateShiftDetailsPermission
                obj[PERMISSION_SUB_TYPE.SHIFT.ACCEPT_REJECT_EMPLOYEE_REQUEST] = updateShiftEmployeeRequestPermission
                filteredPermissions.push(obj)
            }
            if (isTaskPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.TASK,
                    businessId: state.businessId,
                    locationId: state.locationId
                }
                obj[PERMISSION_SUB_TYPE.TASK.ADD_TASK] = addTaskPermission
                obj[PERMISSION_SUB_TYPE.TASK.ASSIGN_TASK] = assignTaskPermission
                obj[PERMISSION_SUB_TYPE.TASK.REMOVE_EMPLOYEE_TASK] = removeEmployeeTaskPermission
                filteredPermissions.push(obj)
            }
            if (isRequestPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.REQUEST,
                    businessId: state.businessId,
                    locationId: state.locationId
                }
                obj[PERMISSION_SUB_TYPE.REQUEST.ACCEPT_REJECT_REQUEST] = acceptOrRejectRequestPermission
                filteredPermissions.push(obj)
            }
            if (isDocumentPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.DOCUMENTS,
                    businessId: state.businessId,
                    locationId: state.locationId
                }
                obj[PERMISSION_SUB_TYPE.DOCUMENTS.ADD_DOCUMENT] = addDocumentPermission
                filteredPermissions.push(obj)
            }
            if (isPolicyPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.POLICIES,
                    businessId: state.businessId,
                    locationId: state.locationId
                }
                obj[PERMISSION_SUB_TYPE.POLICIES.ADD_POLICY] = addPolicyPermission
                filteredPermissions.push(obj)
            }
            if (isAssetPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.ASSET,
                    businessId: state.businessId,
                    locationId: state.locationId
                }
                obj[PERMISSION_SUB_TYPE.ASSET.ADD_ASSET] = addAssetPermission
                obj[PERMISSION_SUB_TYPE.ASSET.ASSIGN_ASSET] = assignAssetPermission
                obj[PERMISSION_SUB_TYPE.ASSET.UPDATE_ASSET] = updateAssetPermission
                obj[PERMISSION_SUB_TYPE.ASSET.VIEW_ALL_ASSET] = viewAllAssetsPermission
                filteredPermissions.push(obj)
            }
            if (isAuditPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.AUDIT,
                    businessId: state.businessId,
                    locationId: state.locationId
                }
                obj[PERMISSION_SUB_TYPE.AUDIT.ASSIGN_AUDIT] = assignAuditPermission
                obj[PERMISSION_SUB_TYPE.AUDIT.UPDATE_AUDIT_STATUS] = updateAuditStatusPermission
                obj[PERMISSION_SUB_TYPE.AUDIT.ADD_AUDIT] = newAuditPermission
                obj[PERMISSION_SUB_TYPE.AUDIT.VIEW_ALL_AUDIT] = viewAllAuditPermission
                filteredPermissions.push(obj)
            }
            if (isVisitorPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.VISITOR,
                    businessId: state.businessId,
                    locationId: state.locationId
                }
                obj[PERMISSION_SUB_TYPE.VISITOR.VIEW_VISITOR_BOOK] = viewVisitorBookPermission
                obj[PERMISSION_SUB_TYPE.VISITOR.UPDATE_ENTRY_SETTINGS] = updateVisitorFormSettingPermission
                filteredPermissions.push(obj)
            }
            if (isPayrollPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.PAYROLL,
                    businessId: state.businessId,
                    locationId: state.locationId
                }
                obj[PERMISSION_SUB_TYPE.PAYROLL.MANAGE_TAX_RULES] = manageTaxRulePermission
                obj[PERMISSION_SUB_TYPE.PAYROLL.MANAGE_EMPLOYEE_PAYROLL] = manageEmployeePayrollPermission
                filteredPermissions.push(obj)
            }
            if (isSuppliesPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.SUPPLIES,
                    businessId: state.businessId,
                    locationId: state.locationId
                }
                obj[PERMISSION_SUB_TYPE.SUPPLIES.ADD_MERCHANT] = addMerchantPermission
                obj[PERMISSION_SUB_TYPE.SUPPLIES.MANAGE_MERCHANT] = manageMerchantPermission
                obj[PERMISSION_SUB_TYPE.SUPPLIES.VIEW_CATEGORIES] = viewCategoriesPermission
                obj[PERMISSION_SUB_TYPE.SUPPLIES.ADD_CATEGORY] = addCategoriesPermission
                obj[PERMISSION_SUB_TYPE.SUPPLIES.VIEW_ITEM] = viewItemPermission
                obj[PERMISSION_SUB_TYPE.SUPPLIES.ADD_ITEM] = addItemPermission
                obj[PERMISSION_SUB_TYPE.SUPPLIES.MANAGE_ITEM] = manageItemPermission
                filteredPermissions.push(obj)
            }
            data.permissions = filteredPermissions
            dispatch(employeeUpdateDetailsRequest(data))
        }
    }

    const showAllowedPermissions = () => {
        if (!isEmpty(employeeDetailSuccess) && !isEmpty(employeeDetailSuccess.data)) {
            let businessId = state.businessId
            let locationId = state.locationId
            let currentPermission = employeeDetailSuccess.data.permissions.filter(item => parseFloat(item.businessId) === parseFloat(businessId) && parseFloat(item.locationId) === parseFloat(locationId))
            if (!isEmpty(currentPermission)) {
                currentPermission.forEach(element => {
                    if (element.type === PERMISSION_TYPE.LOCATION) {
                        setIsLocationPermission(true)
                        setAddLocationPermission(element[PERMISSION_SUB_TYPE.LOCATION.ADD_LOCATION])
                        setUpdateLocationPermission(element[PERMISSION_SUB_TYPE.LOCATION.UPDATE_LOCATION])
                    } else if (element.type === PERMISSION_TYPE.EMPLOYEE) {
                        setIsEmployeePermission(true)
                        setAddEmployeePermission(element[PERMISSION_SUB_TYPE.EMPLOYEE.ADD_EMPLOYEE])
                        setRemoveEmployeePermission(element[PERMISSION_SUB_TYPE.EMPLOYEE.REMOVE_EMPLOYEE])
                        setUpdateEmployeePerPermission(element[PERMISSION_SUB_TYPE.EMPLOYEE.UPDATE_EMPLOYEE])
                    } else if (element.type === PERMISSION_TYPE.PROJECT) {
                        setIsProjectPermission(true)
                        setAddProjectPermission(element[PERMISSION_SUB_TYPE.PROJECT.ADD_PROJECT])
                        setUpdateProjectPermission(element[PERMISSION_SUB_TYPE.PROJECT.UPDATE_DETAILS])
                        setViewProjectCostingPermission(element[PERMISSION_SUB_TYPE.PROJECT.VIEW_COSTING])
                        setUpdateProjectEmployeeRequestPermission(element[PERMISSION_SUB_TYPE.PROJECT.ACCEPT_REJECT_EMPLOYEE_REQUEST])
                    } else if (element.type === PERMISSION_TYPE.SHIFT) {
                        setIsShiftPermission(true)
                        setAddShiftPermission(element[PERMISSION_SUB_TYPE.SHIFT.ADD_SHIFT])
                        setUpdateShiftDetailPermission(element[PERMISSION_SUB_TYPE.SHIFT.UPDATE_SHIFT])
                        setUpdateShiftEmployeeRequestPermission(element[PERMISSION_SUB_TYPE.SHIFT.ACCEPT_REJECT_EMPLOYEE_REQUEST])
                    } else if (element.type === PERMISSION_TYPE.TASK) {
                        setIsTaskPermission(true)
                        setAddTaskPermission(element[PERMISSION_SUB_TYPE.TASK.ADD_TASK])
                        setAssignTaskPermission(element[PERMISSION_SUB_TYPE.TASK.ASSIGN_TASK])
                        setRemoveEmployeeTaskPermission(element[PERMISSION_SUB_TYPE.TASK.REMOVE_EMPLOYEE_TASK])
                    } else if (element.type === PERMISSION_TYPE.REQUEST) {
                        setIsRequestPermission(true)
                        setAcceptOrRejectRequestPermission(element[PERMISSION_SUB_TYPE.REQUEST.ACCEPT_REJECT_REQUEST])
                    } else if (element.type === PERMISSION_TYPE.DOCUMENTS) {
                        setIsDocumentPermission(true)
                        setAddDocumentPermission(element[PERMISSION_SUB_TYPE.DOCUMENTS.ADD_DOCUMENT])
                    } else if (element.type === PERMISSION_TYPE.POLICIES) {
                        setIsPolicyPermission(true)
                        setAddPolicyPermission(element[PERMISSION_SUB_TYPE.POLICIES.ADD_POLICY])
                    } else if (element.type === PERMISSION_TYPE.ASSET) {
                        setIsAssetPermission(true)
                        setAddAssetPermission(element[PERMISSION_SUB_TYPE.ASSET.ADD_ASSET])
                        setAssignAssetPermission(element[PERMISSION_SUB_TYPE.ASSET.ASSIGN_ASSET])
                        setUpdateAssetPermission(element[PERMISSION_SUB_TYPE.ASSET.UPDATE_ASSET])
                        setViewAllAssetsPermission(element[PERMISSION_SUB_TYPE.ASSET.VIEW_ALL_ASSET])
                    } else if (element.type === PERMISSION_TYPE.AUDIT) {
                        setIsAuditPermission(true)
                        setNewAuditPermission(element[PERMISSION_SUB_TYPE.AUDIT.ADD_AUDIT])
                        setViewAllAuditPermission(element[PERMISSION_SUB_TYPE.AUDIT.VIEW_ALL_AUDIT])
                        setAssignAuditPermission(element[PERMISSION_SUB_TYPE.AUDIT.ASSIGN_AUDIT])
                        setUpdateAuditPermission(element[PERMISSION_SUB_TYPE.AUDIT.UPDATE_AUDIT_STATUS])
                    } else if (element.type === PERMISSION_TYPE.VISITOR) {
                        setIsVistorPermission(true)
                        setViewVisitorBookPermission(element[PERMISSION_SUB_TYPE.VISITOR.VIEW_VISITOR_BOOK])
                        setUpdateVisitorFormSettingPermission(element[PERMISSION_SUB_TYPE.VISITOR.UPDATE_ENTRY_SETTINGS])
                    } else if (element.type === PERMISSION_TYPE.PAYROLL) {
                        setIsPayrollPermission(true)
                        setManageTaxRulePermission(element[PERMISSION_SUB_TYPE.PAYROLL.MANAGE_TAX_RULES])
                        setManageEmployeePayrollPermission(element[PERMISSION_SUB_TYPE.PAYROLL.MANAGE_EMPLOYEE_PAYROLL])
                    } else if (element.type === PERMISSION_TYPE.SUPPLIES) {
                        setIsSuppliesPermission(true)
                        setAddMerchantPermission(element[PERMISSION_SUB_TYPE.SUPPLIES.ADD_MERCHANT])
                        setManageMerchantPermission(element[PERMISSION_SUB_TYPE.SUPPLIES.MANAGE_MERCHANT])
                        setViewCategoriesPermission(element[PERMISSION_SUB_TYPE.SUPPLIES.VIEW_CATEGORIES])
                        setAddCategoriesPermission(element[PERMISSION_SUB_TYPE.SUPPLIES.ADD_CATEGORY])
                        setViewItemPermission(element[PERMISSION_SUB_TYPE.SUPPLIES.VIEW_ITEM])
                        setAddItemPermission(element[PERMISSION_SUB_TYPE.SUPPLIES.ADD_ITEM])
                        setManageItemPermission(element[PERMISSION_SUB_TYPE.SUPPLIES.MANAGE_ITEM])
                    }
                });
            }
        }
    }

    const handleSelectManagerClick = () => {
        setSearchQuery('')
        setShowEmployeeModal(true)
        fetchEmployeeList()
    }

    const isPermissionAllowed = (item) => {
        if (item === 'UPDATE') {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.EMPLOYEE, PERMISSION_SUB_TYPE.EMPLOYEE.UPDATE_EMPLOYEE, employeeSelectedBusiness, employeeSelectedLocation)
        } else if (item === 'REMOVE') {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.EMPLOYEE, PERMISSION_SUB_TYPE.EMPLOYEE.REMOVE_EMPLOYEE, employeeSelectedBusiness, employeeSelectedLocation)
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Employee Details' />
                {!isNull(employeeDetailSuccess) && <CommonFormBorder>
                    <div className="ed-name-container" onClick={() => {
                        if (isPermissionAllowed('UPDATE')) {
                            setShowRoleInput(!showRoleInput)
                        }
                    }}>
                        <div className="ed-name-label">{employeeDetailSuccess.data.firstName} {employeeDetailSuccess.data.lastName}</div>
                        <div className="ed-role-container">
                            <div className="ed-role-label">{role}</div>
                            {isPermissionAllowed('UPDATE') && <div className="ed-role-img-container">
                                <img src={require('../../../assets/ic_edit_pen.png')} className="img" />
                            </div>}
                        </div>

                    </div>
                    {showRoleInput && <CommonInputFloatFull
                        type='text'
                        id='role'
                        onChange={e => setRole(e.target.value)}
                        placeholder='Employee Role'
                        value={role}
                    />}
                    <FormFieldLabel className='up-bold-label' label='Employee Code' />
                    <div>{employeeCode}</div>
                    <FormFieldLabel className='up-bold-label' label='Personal Email' />
                    <div>{employeeDetailSuccess.data.personalEmail}</div>
                    <FormFieldLabel className='up-bold-label' label='Mobile' />
                    <div>{employeeDetailSuccess.data.mobile}</div>
                    <div className="ed-label-edit-container" onClick={() => {
                        if (isPermissionAllowed('UPDATE')) {
                            handleSelectManagerClick()
                        }
                    }}>
                        <FormFieldLabel className='up-bold-label' label='Manager/Supervisor' />
                        {isPermissionAllowed('UPDATE') && <div className="ed-role-img-container">
                            <img src={require('../../../assets/ic_edit_pen.png')} className="img" />
                        </div>}
                    </div>

                    <div>{!isEmpty(selectedManager) ? `${selectedManager.firstName} ${selectedManager.lastName}` : '--'}</div>
                    <FormFieldLabel className='up-bold-label' label='Employee Type' />
                    <Select
                        className='select-full-width-no-border'
                        value={employeeType}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={employeeTypeList}
                        placeholder='Select Employee Type'
                        onChange={e => setEmployeeType(e)}
                        isDisabled={!isPermissionAllowed('UPDATE') ? true : false} />
                    {isLoggedInUserBusiness(user) && <div>
                        {!isEmpty(employeeDetailSuccess.data.salaryDetail.salaryDetails) && <div>
                            <FormFieldLabel className='up-bold-label' label='Salary Details' />
                            <div className="ad-purchase-row-container">
                                <div className="ad-purchase-row-item-container">Salary</div>
                                <div className="ad-purchase-row-item-container">{getSalaryDetails(employeeDetailSuccess.data.salaryDetail.salaryDetails) ? `${getSalaryDetails(employeeDetailSuccess.data.salaryDetail.salaryDetails).salary} ${removeSpecialCharAndChangeToPascal(getSalaryDetails(employeeDetailSuccess.data.salaryDetail.salaryDetails).employeeSalaryType)}` : ''}</div>
                            </div>
                            {!isEmpty(getSalaryDeductionDetails(employeeDetailSuccess.data.salaryDetail.deductions)?.deductions) && <div>
                                <FormFieldLabel label='Deductions' />
                                {getSalaryDeductionDetails(employeeDetailSuccess.data.salaryDetail.deductions)?.deductions.map((salItem) => (<div className="ad-purchase-row-container">
                                    <div className="ad-purchase-row-item-container">{salItem.key}</div>
                                    <div className="ad-purchase-row-item-container">{`${salItem.value} ${salItem.type === APP_CONSTANTS.EMPLOYEE_SALARY_DEDUCTION_TYPE.PERCENT ? '%' : ''}`}</div>
                                </div>))}
                            </div>}

                        </div>}

                        <FormFieldLabel className='up-bold-label' label='Onboarding Completed' />
                        <div>{employeeDetailSuccess.data.onboardingCompleted ? 'Yes' : 'No'}</div>
                        <FormFieldLabel className='up-bold-label' label='Business Policies Accepted' />
                        <div>{employeeDetailSuccess.data.allPoliciesAccepted ? 'Yes' : 'No'}</div>
                    </div>}
                    <FormFieldLabel className='up-bold-label' label='Console Access Control/Permissions' />
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isLocationPermission}
                            value={isLocationPermission}
                            onChange={() => {
                                setIsLocationPermission(!isLocationPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Locations</label>
                    </div>
                    {isLocationPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-6">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addLocationPermission}
                                    value={addLocationPermission}
                                    onChange={() => {
                                        setAddLocationPermission(!addLocationPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                            <div className="col-sm-6">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateLocationPermission}
                                    value={updateLocationPermission}
                                    onChange={() => {
                                        setUpdateLocationPermission(!updateLocationPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update Details</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isEmployeePermission}
                            value={isEmployeePermission}
                            onChange={() => {
                                setIsEmployeePermission(!isEmployeePermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Employees</label>
                    </div>
                    {isEmployeePermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addEmployeePermission}
                                    value={addEmployeePermission}
                                    onChange={() => {
                                        setAddEmployeePermission(!addEmployeePermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={removeEmployeePermission}
                                    value={removeEmployeePermission}
                                    onChange={() => {
                                        setRemoveEmployeePermission(!removeEmployeePermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Remove Employee</label>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateEmployeePerPermission}
                                    value={updateEmployeePerPermission}
                                    onChange={() => {
                                        setUpdateEmployeePerPermission(!updateEmployeePerPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update Details/Permissions</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isPayrollPermission}
                            value={isPayrollPermission}
                            onChange={() => {
                                setIsPayrollPermission(!isPayrollPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Payroll</label>
                    </div>
                    {isPayrollPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-6">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={manageTaxRulePermission}
                                    value={manageTaxRulePermission}
                                    onChange={() => {
                                        setManageTaxRulePermission(!manageTaxRulePermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Manage Tax Rules</label>
                            </div>
                            <div className="col-sm-6">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={manageEmployeePayrollPermission}
                                    value={manageEmployeePayrollPermission}
                                    onChange={() => {
                                        setManageEmployeePayrollPermission(!manageEmployeePayrollPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Empoyee Payroll</label>
                            </div>
                        </div>
                    </div>
                    }
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isProjectPermission}
                            value={isProjectPermission}
                            onChange={() => {
                                setIsProjectPermission(!isProjectPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Projects</label>
                    </div>
                    {isProjectPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addProjectPermission}
                                    value={addProjectPermission}
                                    onChange={() => {
                                        setAddProjectPermission(!addProjectPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateProjectPermission}
                                    value={updateProjectPermission}
                                    onChange={() => {
                                        setUpdateProjectPermission(!updateProjectPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={viewProjectCostingPermission}
                                    value={viewProjectCostingPermission}
                                    onChange={() => {
                                        setViewProjectCostingPermission(!viewProjectCostingPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">View Costing</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateProjectEmployeeRequestPermission}
                                    value={updateProjectEmployeeRequestPermission}
                                    onChange={() => {
                                        setUpdateProjectEmployeeRequestPermission(!updateProjectEmployeeRequestPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update Employee Requests</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isShiftPermission}
                            value={isShiftPermission}
                            onChange={() => {
                                setIsShiftPermission(!isShiftPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Shifts</label>
                    </div>
                    {isShiftPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addShiftPermission}
                                    value={addShiftPermission}
                                    onChange={() => {
                                        setAddShiftPermission(!addShiftPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateShiftDetailsPermission}
                                    value={updateShiftDetailsPermission}
                                    onChange={() => {
                                        setUpdateShiftDetailPermission(!updateShiftDetailsPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update Details</label>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateShiftEmployeeRequestPermission}
                                    value={updateShiftEmployeeRequestPermission}
                                    onChange={() => {
                                        setUpdateShiftEmployeeRequestPermission(!updateShiftEmployeeRequestPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update Employee Requests</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isTaskPermission}
                            value={isTaskPermission}
                            onChange={() => {
                                setIsTaskPermission(!isTaskPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Tasks</label>
                    </div>
                    {isTaskPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addTaskPermission}
                                    value={addTaskPermission}
                                    onChange={() => {
                                        setAddTaskPermission(!addTaskPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={assignTaskPermission}
                                    value={assignTaskPermission}
                                    onChange={() => {
                                        setAssignTaskPermission(!assignTaskPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Assign Task</label>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={removeEmployeeTaskPermission}
                                    value={removeEmployeeTaskPermission}
                                    onChange={() => {
                                        setRemoveEmployeeTaskPermission(!removeEmployeeTaskPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Un-Assign Task</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isRequestPermission}
                            value={isRequestPermission}
                            onChange={() => {
                                setIsRequestPermission(!isRequestPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Requests</label>
                    </div>
                    {isRequestPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-12">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={acceptOrRejectRequestPermission}
                                    value={acceptOrRejectRequestPermission}
                                    onChange={() => {
                                        setAcceptOrRejectRequestPermission(!acceptOrRejectRequestPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Approve/Reject Request</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isDocumentPermission}
                            value={isDocumentPermission}
                            onChange={() => {
                                setIsDocumentPermission(!isDocumentPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Documents</label>
                    </div>
                    {isDocumentPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-12">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addDocumentPermission}
                                    value={addDocumentPermission}
                                    onChange={() => {
                                        setAddDocumentPermission(!addDocumentPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isPolicyPermission}
                            value={isPolicyPermission}
                            onChange={() => {
                                setIsPolicyPermission(!isPolicyPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Policies</label>
                    </div>
                    {isPolicyPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-12">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addPolicyPermission}
                                    value={addPolicyPermission}
                                    onChange={() => {
                                        setAddPolicyPermission(!addPolicyPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isAssetPermission}
                            value={isAssetPermission}
                            onChange={() => {
                                setIsAssetPermission(!isAssetPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Assets</label>
                    </div>
                    {isAssetPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={viewAllAssetsPermission}
                                    value={viewAllAssetsPermission}
                                    onChange={() => {
                                        setViewAllAssetsPermission(!viewAllAssetsPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">View All</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addAssetPermission}
                                    value={addAssetPermission}
                                    onChange={() => {
                                        setAddAssetPermission(!addAssetPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={assignAssetPermission}
                                    value={assignAssetPermission}
                                    onChange={() => {
                                        setAssignAssetPermission(!assignAssetPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Assign Asset</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateAssetPermission}
                                    value={updateAssetPermission}
                                    onChange={() => {
                                        setUpdateAssetPermission(!updateAssetPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isAuditPermission}
                            value={isAuditPermission}
                            onChange={() => {
                                setIsAuditPermission(!isAuditPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Audit</label>
                    </div>
                    {isAuditPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={viewAllAuditPermission}
                                    value={viewAllAuditPermission}
                                    onChange={() => {
                                        setViewAllAuditPermission(!viewAllAuditPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">View All</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={newAuditPermission}
                                    value={newAuditPermission}
                                    onChange={() => {
                                        setNewAuditPermission(!newAuditPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={assignAuditPermission}
                                    value={assignAuditPermission}
                                    onChange={() => {
                                        setAssignAuditPermission(!assignAuditPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Assign Audit</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateAuditStatusPermission}
                                    value={updateAuditStatusPermission}
                                    onChange={() => {
                                        setUpdateAuditPermission(!updateAuditStatusPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update Status</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isVisitorPermission}
                            value={isVisitorPermission}
                            onChange={() => {
                                setIsVistorPermission(!isVisitorPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Visitor Book</label>
                    </div>
                    {isVisitorPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-6">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={viewVisitorBookPermission}
                                    value={viewVisitorBookPermission}
                                    onChange={() => {
                                        setViewVisitorBookPermission(!viewVisitorBookPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">View Book</label>
                            </div>
                            <div className="col-sm-6">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateVisitorFormSettingPermission}
                                    value={updateVisitorFormSettingPermission}
                                    onChange={() => {
                                        setUpdateVisitorFormSettingPermission(!updateVisitorFormSettingPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update Entry Setting</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isSuppliesPermission}
                            value={isSuppliesPermission}
                            onChange={() => {
                                setIsSuppliesPermission(!isSuppliesPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Supplies</label>
                    </div>
                    {isSuppliesPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addMerchantPermission}
                                    value={addMerchantPermission}
                                    onChange={() => {
                                        setAddMerchantPermission(!addMerchantPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add Merchant</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={manageMerchantPermission}
                                    value={manageMerchantPermission}
                                    onChange={() => {
                                        setManageMerchantPermission(!manageMerchantPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Manage Merchant</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={viewCategoriesPermission}
                                    value={viewCategoriesPermission}
                                    onChange={() => {
                                        setViewCategoriesPermission(!viewCategoriesPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">View Categories</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addCategoriesPermission}
                                    value={addCategoriesPermission}
                                    onChange={() => {
                                        setAddCategoriesPermission(!addCategoriesPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add Category</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={viewItemPermission}
                                    value={viewItemPermission}
                                    onChange={() => {
                                        setViewItemPermission(!viewItemPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">View Supplies</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addItemPermission}
                                    value={addItemPermission}
                                    onChange={() => {
                                        setAddItemPermission(!addItemPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add Supplies</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={manageItemPermission}
                                    value={manageItemPermission}
                                    onChange={() => {
                                        setManageItemPermission(!manageItemPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Manage Supplies</label>
                            </div>
                        </div>
                    </div>}
                    <ButtonRow isVertical={true}>
                        {isPermissionAllowed('UPDATE') &&
                            <CommonButton isBig={true} label='Update Details' onClick={() => { handleUpdateDetails() }} />}
                        {isPermissionAllowed('REMOVE') && <CommonButton isBig={true} label='Remove Employee' onClick={() => { setShowRemoveEmployeeModal(true) }} />}
                    </ButtonRow>
                </CommonFormBorder>}
                {!isNull(employeeDetailError) && <div>{employeeDetailError.message}</div>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowEmployeeModal(false) }}
                show={showEmployeeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Select Manager/Supervisor
                </Modal.Header>
                <Modal.Body>
                    <div className="ol-search-parent-container">
                        <div className="ol-search-row-parent-container">
                            <div className="ol-search-input-container">
                                <input type="text" className="ol-input-no-border" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search Employee" />
                            </div>
                            <div className="ol-search-icon-container" onClick={() => { fetchEmployeeList() }}>
                                <img src={require('../../../assets/ic_search_orange.png')} className="img" />
                            </div>
                        </div>
                    </div>
                    {!isEmpty(employeeListSuccess) && <div className="ae-emp-list-container">
                        {!isEmpty(employeeListSuccess.data) && employeeListSuccess.data.map(e => (<div className="ae-emp-list-item-container">
                            <div className="ae-emp-list-item-content-container">
                                <div className="ae-emp-name-label">{e.firstName} {e.lastName}</div>
                                <div className="ae-emp-code-label">{e.employeeCode}</div>
                                <div className="ae-emp-name-label">{e.role}</div>
                            </div>
                            <div className="ae-row-btn-container" onClick={() => {
                                setSelectedManager(e)
                                setShowEmployeeModal(false)
                            }}>Select</div>
                        </div>))}
                    </div>}
                    <div className="td-or-label">OR</div>
                    <div className="td-or-btn-container">
                        <CommonButton label='Assign Self' onClick={() => {
                            setSelectedManager(user.data.userDetails)
                            setShowEmployeeModal(false)
                        }} />
                    </div>
                    {!isEmpty(employeeListError) && <div className="content-error">{employeeListError.message}</div>}
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowRemoveEmployeeModal(false) }}
                show={showRemoveEmployeeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Remove employee
                </Modal.Header>
                <Modal.Body>
                    <SubTextLabel label='Enter details to remove employee' />
                    <CommonInputFloatFull
                        type='text'
                        id='reason'
                        onChange={e => setReason(e.target.value)}
                        placeholder='Reason'
                        value={reason}
                    />
                    <CommonInputFloatFull
                        type='text'
                        id='feedback'
                        onChange={e => setFeedback(e.target.value)}
                        placeholder='Feedback'
                        value={feedback}
                        multiline={true}
                        rows={2}
                    />
                    <div className="pd-date-parent-container">
                        <FormFieldLabel label='Select End Date' />
                        <DatePicker
                            className="as-date-container"
                            selected={endDate}
                            onChange={(date) => {
                                setEndDate(date)
                            }}
                            dateFormat="MMMM d, yyyy"
                        />
                    </div>
                    <ButtonRow>
                        <CommonButton label='Submit'
                            onClick={() => {
                                handleRemoveEmployee()
                            }}
                        />
                    </ButtonRow>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default EmployeeDetail